<template>
    <div class="jiejue">
        <div class="top-banner" style="background: #5060e6">
            <div>
                <div  :style="tittlestyle" class="fl tittle">
                    <h2>虚拟电商解决方案</h2>
                    <p>帮助您建立去中心化的电商体系，挖掘潜在用户利用人脉关系网，快速引爆线上流量，打造超人气商城</p>
                </div>
                <img  src="/site_static/img/cm-ban.png" alt="" class="fr banner-img" :style="banlogostyle">
            </div>
        </div>
        <div class="relationship">
            <div class="title" style="padding-top: 50px;">
                <h3>社交圈低成本裂变营销，实现大爆炸式传播</h3>
                <p style="padding-bottom: 12px;">社交场景与营销活动相结合通过朋友圈分享传播，利用佣金等鼓励机制，实现大爆炸式指数级传播，</p>
                <p>迅速提升品牌影响力，帮助您吸引线上粉丝获取海量用户</p>
            </div>
            <div class="marginauto">
                <div class="rela-left">
                    <div class="rela-item" @mouseenter="changeocpimg(0)">
                        <p class="rela-tit">社交场景营销</p>
                        <p class="rela-subtit">基于社交场景的销售模式，打造强大的新人销售网络快速销货</p>
                    </div>
                    <div class="rela-item" @mouseenter="changeocpimg(1)">
                        <p class="rela-tit">全渠道支持</p>
                        <p class="rela-subtit">多触点面向移动社交圈，科学推广帮助您轻松引流，交易快速变现</p>
                    </div>
                </div>
                <img class="rela-img" src="/site_static/img/soci-sol.png"  :class="ocpimg[0]">
                <img class="rela-img" src="/site_static/img/soci-channel.png" :class="ocpimg[1]" >
                <img class="rela-img" src="/site_static/img/social-data.png"  :class="ocpimg[2]">
                <img class="rela-img" src="/site_static/img/social-comm.png"  :class="ocpimg[3]" >
                <div class="rela-left">
                    <div class="rela-item" @mouseenter="changeocpimg(2)">
                        <p class="rela-tit">多数据分析能力</p>
                        <p class="rela-subtit">通过页面流量、商品库存、转化数据等帮助您制定专业营销方案</p>
                    </div>
                    <div class="rela-item" @mouseenter="changeocpimg(3)">
                        <p class="rela-tit">强大的营销能力</p>
                        <p class="rela-subtit">帮助您建立营销日历，针对不同时间段精准推广宣传，更便捷</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="title" style="padding-top: 50px">
            <h3>社交电商已成为四岸上时代主流，可满足多样化业务场景</h3>
            <p>我们将为您制定一站式电商营销解决方案，快速吸引粉丝，让您不错过商机</p>
        </div>
        <div class="tradition">
            <img src="/site_static/img/social-icon.png">
            <div class="flex social-main marginauto">
                <p>会员群体</p>
                <p>营销活动</p>
                <p>数据统计</p>
                <p>代理改价</p>
            </div>
        </div>
        <div class="poster">
            <div class="title" style="padding: 50px 0 30px 0">
                <h3>强大的功能支持</h3>
                <p>代理改价、卡密拼团、API系统等多种强大的功能帮助商城快速传播和发展。</p>
            </div>
            <div class="flex poster-container marginauto">
                <div class="poster-item">
                    <img src="/site_static/img/poster-goods.png">
                    <p class="poster-subtit">API管理-对接卡商系统实现在线直充</p>
                </div>
                <div class="poster-item">
                    <img src="/site_static/img/poster.png">
                    <p class="poster-subtit">代理改价-招募代理快速分享</p>
                </div>
                <div class="poster-item">
                    <img src="/site_static/img/poster-code.png">
                    <p class="poster-subtit">卡密拼团-邀请好友一起拼团购买cdk</p>
                </div>
            </div>
        </div>
        <div class="flex member marginauto">
            <div class="member-left" style="width: 540px;">
                <div class="member-tit">玩转社交电商，解锁多种盈利方式</div>
                <div class="member-subtit">鼓励会员主动分享传播，吸引新用户，培养老用户的消费习惯，提升忠诚度，一次锁定会员多次盈利，提升商城复购率</div>
            </div>
            <img src="/site_static/img/shop-bag.png" class="member-right">
        </div>
        <div class="member social-mem">
            <div class="marginauto flex">
                <img src="/site_static/img/friend-circle.png" style="margin-left: 100px;">
                <div class="member-right" style="width: 600px;">
                    <div class="member-tit">依托朋友圈口碑传播，建立个性化电商品牌</div>
                    <div class="member-subtit">借助微信朋友圈10亿强大的社交网络，帮助您推广宣传，投入成本低宣传范围广，为您快速提升电商品牌影响力</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'jiejue',
        data(){
            return{
                tittlestyle:{},
                banlogostyle:{},
                ocpimg:['ocpimg','','','']
            }
        },
        created: function () {
            let serf = this
            setTimeout(function () {
                serf.tittlestyle={
                    bottom:'125px',
                    opacity: 1}
                serf.banlogostyle={
                    bottom:'45px',
                    opacity: 1}
            },0)

        },
        methods:{
            changeocpimg(k){
                for (var i = 0 ;i<this.ocpimg.length;i++){
                    this.$set(this.ocpimg,i, '');
                }
                this.$set(this.ocpimg,k, 'ocpimg');
            }
        }
    }
</script>
<style scoped>
    h3{
        margin: 0;
    }
    ul{
        list-style: none;
    }
    p{
        margin: 0;
    }
    .flex{
        display: flex;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .top-banner{
        background: linear-gradient(90deg,#ff825c,#ff5d5c);
        color: #fff;
        width: 100%;
        height: 480px;
    }
    .top-banner>div{
        width: 1200px;
        margin: auto;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tittle{
        position: absolute;
        height: 220px;
        transition: all .5s;
        bottom: 0;
        opacity: 0;
    }
    .poster-item>img{
        width: 232px;
        height: 338px;
    }
    .tittle>h2{
        font-size: 30px;
        margin: 50px 20px 28px 0;
        font-weight: 500;
    }
    .tittle>p{
        font-size: 18px;
        width: 500px;
        line-height: 36px;
        margin-bottom: 30px;
        text-align: left;
    }
    .banner-img{
        position: absolute;
        bottom: 0px;
        opacity: 0;
        transition: all .5s;
    }
    .title {
        padding: 80px 0 50px 0;
        text-align: center;
    }
    .title h3 {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 20px;
        font-weight: 500;
    }
    .title p {
        font-size: 18px;
        color: #5d6494;
    }
    .relationship {
        background-color: #f5fbff;
        padding-bottom: 60px;
    }
    .relationship .marginauto {
         padding: 76px 154px;
         display: flex;
         justify-content: space-between;
         background: url(/site_static/img/social-low.png) no-repeat;
         background-position: center;
         box-sizing: border-box;
         position: relative;
     }
    .rela-left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 318px;
    }
    .relationship .rela-item {
        width: 200px;
        font-size: 16px;
        color: #3B426B;
        line-height: 30px;
        position: relative;
    }
    .relationship .rela-item:before {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #5a81ff;
        left: -20px;
        top: 10px;
    }
    .relationship .rela-tit {
        font-size: 24px;
        padding-bottom: 4px;
        font-weight: 500;
        color: #3b426b;
    }
    .relationship .rela-tit {
        font-size: 24px;
        padding-bottom: 4px;
        font-weight: 500;
        color: #3b426b;
    }
    .marginauto {
        margin: 0 auto;
        width: 1200px;
    }
    .relationship .rela-img {
        position: absolute;
        left: 363px;
        top: 160px;
        transition: all .35s;
        opacity: 0;
    }
    .tradition img {
        margin: 0 auto;
        margin-bottom: 50px;
    }
    .social-main {
        justify-content: space-around;
        font-size: 22px;
        color: #3b426b;
        padding-bottom: 50px;
    }
    .poster{
        background: #f5fbff;
    }
    .poster-item {
        margin: 0 30px;
    }
    .poster-subtit {
        font-size: 14px;
        color: #5d6494;
        text-align: center;
        padding-top: 28px;
    }
    .poster-container {
        padding-bottom: 50px;
        justify-content: center;
    }
    .member {
        align-items: center;
        padding-top: 50px;
    }
    .member-left {
        padding-left: 40px;
        width: 440px;
    }
    .member-right {
        padding-left: 160px;
    }
    .member-tit {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 24px;
    }
    .member-subtit {
        line-height: 30px;
        font-size: 18px;
        color: #5d6494;
    }
    .social-mem {
        background: #f5fbff;
        padding-top: 0;
    }
    .social-mem .marginauto {
        height: 460px;
        align-items: center;
    }
    .ocpimg{
        opacity: 1 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/product/jiejue.vue